__turbopack_context__.v({
  "band": "NeonLayer-module__d-ivWG__band",
  "breathe": "NeonLayer-module__d-ivWG__breathe",
  "fill": "NeonLayer-module__d-ivWG__fill",
  "glow": "NeonLayer-module__d-ivWG__glow",
  "layer": "NeonLayer-module__d-ivWG__layer",
  "lens": "NeonLayer-module__d-ivWG__lens",
  "line": "NeonLayer-module__d-ivWG__line",
  "powerOn": "NeonLayer-module__d-ivWG__powerOn",
  "sector": "NeonLayer-module__d-ivWG__sector",
  "spark": "NeonLayer-module__d-ivWG__spark",
  "travel": "NeonLayer-module__d-ivWG__travel",
  "turn": "NeonLayer-module__d-ivWG__turn",
});
